"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var operation_condition_1 = require("./operation-condition");
exports.ImmutableOperationCondition = operation_condition_1.ImmutableOperationCondition;
var element_state_condition_1 = require("./element-state-condition");
exports.ImmutableElementStateCondition = element_state_condition_1.ImmutableElementStateCondition;
var element_value_condition_1 = require("./element-value-condition");
exports.ImmutableElementValueCondition = element_value_condition_1.ImmutableElementValueCondition;
var unsupported_conditions_1 = require("./unsupported-conditions");
exports.ImmutableUnsupportedCondition = unsupported_conditions_1.ImmutableUnsupportedCondition;
var element_comparison_condition_1 = require("./element-comparison-condition");
exports.ImmutableElementComparisonCondition = element_comparison_condition_1.ImmutableElementComparisonCondition;
var form_action_1 = require("./form-action");
exports.ImmutableFormAction = form_action_1.ImmutableFormAction;
var form_rule_1 = require("./form-rule");
exports.ImmutableFormRule = form_rule_1.ImmutableFormRule;
var rule_constants_1 = require("./rule-constants");
exports.conditionTypes = rule_constants_1.conditionTypes;
exports.actionTypes = rule_constants_1.actionTypes;
exports.operationTypes = rule_constants_1.operationTypes;
var rule_helpers_1 = require("./rule-helpers");
exports.isConditionElementComparisonType = rule_helpers_1.isConditionElementComparisonType;
exports.isConditionElementValueType = rule_helpers_1.isConditionElementValueType;
exports.isConditionElementStateType = rule_helpers_1.isConditionElementStateType;
exports.isConditionOperatorType = rule_helpers_1.isConditionOperatorType;
exports.isStaticConditionType = rule_helpers_1.isStaticConditionType;
var static_condition_1 = require("./static-condition");
exports.ImmutableStaticCondition = static_condition_1.ImmutableStaticCondition;
var program_state_condition_1 = require("./program-state-condition");
exports.ImmutableProgramStateCondition = program_state_condition_1.ImmutableProgramStateCondition;
var program_value_condition_1 = require("./program-value-condition");
exports.ImmutableProgramValueCondition = program_value_condition_1.ImmutableProgramValueCondition;
/**
 * Converts a JS object definition of a form condition into an immutable definition of a form condition.
 * @param condition normal js object definition of a form condition
 */
function convertConditionToImmutable(condition) {
    switch (condition.type) {
        case rule_constants_1.conditionTypes.operator:
            return new operation_condition_1.ImmutableOperationCondition(condition);
        case rule_constants_1.conditionTypes.empty:
        case rule_constants_1.conditionTypes.notEmpty:
        case rule_constants_1.conditionTypes.earlierThanNow:
        case rule_constants_1.conditionTypes.earlierThanNowOrEqual:
        case rule_constants_1.conditionTypes.laterThanNow:
        case rule_constants_1.conditionTypes.laterThanNowOrEqual:
        case rule_constants_1.conditionTypes.today:
        case rule_constants_1.conditionTypes.notToday:
        case rule_constants_1.conditionTypes.thisWeek:
        case rule_constants_1.conditionTypes.notThisWeek:
        case rule_constants_1.conditionTypes.thisMonth:
        case rule_constants_1.conditionTypes.notThisMonth:
        case rule_constants_1.conditionTypes.thisYear:
        case rule_constants_1.conditionTypes.notThisYear:
            return new element_state_condition_1.ImmutableElementStateCondition(condition);
        case rule_constants_1.conditionTypes.equal:
        case rule_constants_1.conditionTypes.notEqual:
        case rule_constants_1.conditionTypes.equalLabel:
        case rule_constants_1.conditionTypes.notEqualLabel:
        case rule_constants_1.conditionTypes.equalMaskedMulti:
        case rule_constants_1.conditionTypes.notEqualMaskedMulti:
        case rule_constants_1.conditionTypes.contains:
        case rule_constants_1.conditionTypes.containsString:
        case rule_constants_1.conditionTypes.notContainString:
        case rule_constants_1.conditionTypes.lessThan:
        case rule_constants_1.conditionTypes.lessThanOrEqual:
        case rule_constants_1.conditionTypes.greaterThan:
        case rule_constants_1.conditionTypes.greaterThanOrEqual:
        case rule_constants_1.conditionTypes.beginsWith:
        case rule_constants_1.conditionTypes.notBeginWith:
        case rule_constants_1.conditionTypes.endsWith:
        case rule_constants_1.conditionTypes.notEndWith:
        case rule_constants_1.conditionTypes.matchesAny:
        case rule_constants_1.conditionTypes.notMatchAny:
        case rule_constants_1.conditionTypes.matchesAnyMaskedMulti:
        case rule_constants_1.conditionTypes.notMatchAnyMaskedMulti:
        case rule_constants_1.conditionTypes.matchesEvery:
        case rule_constants_1.conditionTypes.notMatchEvery:
        case rule_constants_1.conditionTypes.between:
        case rule_constants_1.conditionTypes.notBetween:
        case rule_constants_1.conditionTypes.last:
        case rule_constants_1.conditionTypes.notLast:
        case rule_constants_1.conditionTypes.next:
        case rule_constants_1.conditionTypes.notNext:
            return new element_value_condition_1.ImmutableElementValueCondition(condition);
        case rule_constants_1.conditionTypes.equalElement:
        case rule_constants_1.conditionTypes.notEqualElement:
        case rule_constants_1.conditionTypes.lessThanElement:
        case rule_constants_1.conditionTypes.lessThanOrEqualElement:
        case rule_constants_1.conditionTypes.greaterThanElement:
        case rule_constants_1.conditionTypes.greaterThanOrEqualElement:
            return new element_comparison_condition_1.ImmutableElementComparisonCondition(condition);
        case rule_constants_1.conditionTypes.static:
            return new static_condition_1.ImmutableStaticCondition(condition);
        case rule_constants_1.conditionTypes.programEmpty:
        case rule_constants_1.conditionTypes.programNotEmpty:
            return new program_state_condition_1.ImmutableProgramStateCondition(condition);
        case rule_constants_1.conditionTypes.programContains:
        case rule_constants_1.conditionTypes.programNotContains:
        case rule_constants_1.conditionTypes.programMatchesAny:
        case rule_constants_1.conditionTypes.programNotMatchesAny:
        case rule_constants_1.conditionTypes.programMatchesAll:
        case rule_constants_1.conditionTypes.programNotMatchesAll:
            return new program_value_condition_1.ImmutableProgramValueCondition(condition);
        default: return new unsupported_conditions_1.ImmutableUnsupportedCondition();
    }
}
exports.convertConditionToImmutable = convertConditionToImmutable;
/**
 * checks to see if a rule is comprised of supported conditions and actions
 * @param rule the rule we are evaluating
 */
function isRuleSupported(rule) {
    var conditionSupported = isConditionSupported(rule.condition);
    var actionsSupported = !!rule.conditionActions ? rule.conditionActions.every(function (action) { return isActionSupported(action); }) : true;
    var preConditionactionsSupported = !!rule.preConditionActions ? rule.preConditionActions.every(function (action) { return isActionSupported(action); }) : true;
    return conditionSupported && actionsSupported && preConditionactionsSupported;
}
exports.isRuleSupported = isRuleSupported;
/**
 * checks to see if the condition has supported type values
 * @param condition condition being evaluated
 */
function isConditionSupported(condition) {
    if (!condition)
        return false;
    var supported = enumContainsValue(rule_constants_1.conditionTypes, condition.type);
    if (!supported)
        return false;
    switch (condition.type) {
        case rule_constants_1.conditionTypes.operator:
            return condition.conditions.every(function (subCondition) { return isConditionSupported(subCondition); });
        default: return supported;
    }
}
exports.isConditionSupported = isConditionSupported;
/**
 * checks to see if the action has supported type values
 * @param action action being evaluated
 */
function isActionSupported(action) {
    if (!action)
        return false;
    var supported = enumContainsValue(rule_constants_1.actionTypes, action.type);
    return supported;
}
exports.isActionSupported = isActionSupported;
/**
 * checks to see if a certain string is a valid value in a string enum
 * @param enumObject a string enum
 * @param value the value we are searching for in the enum
 */
function enumContainsValue(enumObject, value) {
    var keys = Object.keys(enumObject);
    return keys.some(function (key) { return enumObject[key] === value; });
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-rules/index.js
// module id = 1108
// module chunks = 0